import { z } from 'zod';
import { objectId, timestampFields, FieldMetadata } from './base';

/**
 * EmailTemplate Schema
 * Per-organization custom email templates that fire alongside the built-in
 * transactional emails. Identified by `templateKey` so future template types
 * can be added without schema changes.
 *
 * Current keys:
 *   - team_registration_confirmation
 *   - payment_confirmation
 */

export const EMAIL_TEMPLATE_KEYS = [
  'team_registration_confirmation',
  'payment_confirmation',
] as const;

export type EmailTemplateKey = (typeof EMAIL_TEMPLATE_KEYS)[number];

export const EmailTemplateSchema = z.object({
  _id: objectId,
  organization: objectId,
  templateKey: z.string(),
  subject: z.string().default(''),
  body: z.string().default(''),
  enabled: z.boolean().default(true),
  ...timestampFields,
});

export type EmailTemplate = z.infer<typeof EmailTemplateSchema>;

export const emailTemplateMetadata: Record<string, FieldMetadata> = {
  _id: { hidden: true },
  organization: { ref: 'Organization', hidden: true },
  templateKey: { label: 'Template Key', editable: false },
  subject: { label: 'Subject', editable: true },
  body: { label: 'Body', editable: true },
  enabled: { label: 'Enabled', editable: true },
  created: { hidden: true },
  updated: { hidden: true },
};
